<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sec_chap">Corrections to Volume Two</h2>
<p class="noindent"><span class="dropcap">T</span>o ensure compatibility between the two narrative volumes and the <em class="italic">Documentary Companion</em>, the following corrections are necessary to the marginal annotations in Volume two of the narrative:</p>
<p class="bullett"><span class="bull">•</span> <span href="#/xhtml/21_Chapter_11#ch11sec5" title="Link target outside of Sample">Page 141</span> – change R, 21 to R, 1.</p>
<p class="bullet"><span class="bull">•</span> <span href="#/xhtml/21_Chapter_11#page_142" title="Link target outside of Sample">Page 142</span> – change R, 22 to R, 2.</p>
<p class="bullet"><span class="bull">•</span> <span href="#/xhtml/24_Chapter_14#page_196" title="Link target outside of Sample">Page 196</span> – change S, 20 to S, 17.</p>
<p class="bullet"><span class="bull">•</span> <span href="#/xhtml/25_Chapter_15#page_218" title="Link target outside of Sample">Page 218</span> – change S, 24 to S, 23.</p>
<p class="bullet"><span class="bull">•</span> <span href="#/xhtml/25_Chapter_15a#page_243" title="Link target outside of Sample">Page 243</span> – change S, 32 to S, 35 and change S, 34 to S, 33.</p>
<p class="bullet"><span class="bull">•</span> <span href="#/xhtml/25_Chapter_15b#ch15sec57" title="Link target outside of Sample">Page 283</span> – change S, 48-51 to S, 48, 51, 49, and 50.</p>
<p class="bullet"><span class="bull">•</span> <span href="#/xhtml/29_Chapter_19a#page_421" title="Link target outside of Sample">Page 421</span>, note 4, ln. 4 – change “Impossibility of” to “Necessity for”</p>
<p class="bullet"><span class="bull">•</span> <span href="#/xhtml/31_Chapter_21" title="Link target outside of Sample">Appendix U</span>, which pertains to the operations by <em class="italic">Armeegruppe</em> Guderian and the Briansk Front’s Roslavl’-Novozybkov offensive, is split into three parts associated with three distinct periods of time.</p>
<p class="bullet"><span class="bull">•</span> <span href="#/xhtml/31_Chapter_21#page_493" title="Link target outside of Sample">Page 493</span> – Add “See Volume 3 (Documents) U, 77.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Corrections.vue?1695b4e1